
import { NavLink, useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import Fqicon from "../../assets/img/Fq.png";
import LogoutIcon from "../../assets/icons/LogoutIcon.svg";
import Icon from "./Icon";

export default function Sidebar({ menus, isOpen, closeSidebar }) {
  const navigate = useNavigate();

  const activeClass = `
    bg-gradient-to-r
    from-teal-500/20 to-blue-500/20
    dark:from-cyan-400/20 dark:to-indigo-500/20
    text-teal-200 dark:text-cyan-300
  `;

  const inactiveClass = "text-gray-300 hover:bg-white/10";

  
  return (
    <aside
      className={`
        fixed xl:static
        inset-y-0 left-0
        z-30
        w-80         
        bg-[#0D3744] dark:bg-slate-900
        text-white
        transform transition-transform duration-300
        ${isOpen ? "translate-x-0" : "-translate-x-full"}
        xl:translate-x-0
        flex flex-col
      `}
    >

      <div className="flex items-center justify-between px-4 py-3 xl:hidden border-b border-white/10">
        <img
          src={Fqicon}
          alt="FQ Logo"
          className="h-10 w-auto object-contain"
        />

        <button
          onClick={closeSidebar}
          className="p-2 rounded-lg hover:bg-white/10 transition"
          aria-label="Close sidebar"
        >
          <X size={22} />
        </button>
      </div>

      {/* MENU */}
      <nav className="flex-1 px-3 py-4 space-y-2 overflow-y-auto">
        {menus.map((item, idx) => (
          <NavLink
            key={idx}
            to={item.path}
            onClick={closeSidebar}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-lg text-base font-medium transition
               ${isActive ? activeClass : inactiveClass}`
            }
          >
            <Icon base64={item.icon} width={20} height={20} />
            <span>{item.name}</span>
          </NavLink>
        ))}
      </nav>

      {/* LOGOUT */}
      <div className="px-4 py-4 border-t border-white/10">
        <button
          className="w-full flex items-center gap-3 px-4 py-3 rounded-lg
                     text-base text-red-400 hover:bg-red-500/10 transition"
          onClick={() => {
            closeSidebar();
            navigate("/logout", { replace: true });
          }}
        >
          <img src={LogoutIcon} alt="Logout" className="w-5 h-5" />
          Logout
        </button>
      </div>
    </aside>
  );
}
